import { render } from "./ContactsEntitiesByPeopleView.vue?vue&type=template&id=15368bea"
import script from "./ContactsEntitiesByPeopleView.vue?vue&type=script&lang=js"
export * from "./ContactsEntitiesByPeopleView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__